import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core'
import { AnalyticsService } from '@app/core/_services/analytics.service'
import { DialogService } from '@app/core/_services/dialog.service'
import { MessageModule } from 'primeng/message'

const BANNER_NAME = 'Group Meeting: Host Beta Announcement'
const BANNER_SOURCE = 'groupMeetingHostBetaBanner'

@Component({
    selector: 'fm-group-meeting-host-beta-banner',
    standalone: true,
    imports: [MessageModule],
    templateUrl: './group-meeting-host-beta-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupMeetingHostBetaBannerComponent implements OnInit {
    @Output() dismissBanner = new EventEmitter<void>()

    public pMessageScopedToken = {
        content: {
            gap: '0.5rem',
            padding: '0rem 0.75rem',
        },
    }

    constructor(
        private analyticsService: AnalyticsService,
        private dialogService: DialogService,
    ) {}

    ngOnInit(): void {
        this.analyticsService.logViewedBannerEvent(BANNER_NAME, { source: BANNER_SOURCE })
    }

    onClickLearnMore(): void {
        this.analyticsService.logGroupMeetingClick('learnMoreAboutGroupMeetings', BANNER_SOURCE)
        this.dialogService.openGroupMeetingsHostBetaAnnouncementDialog()
    }

    onClickDismiss(): void {
        this.analyticsService.logGroupMeetingClick(
            'dismissGroupMeetingsHostBetaBanner',
            BANNER_SOURCE,
        )
        this.dismissBanner.emit()
    }
}
